module.exports = __webpack_public_path__ + "img/miei-avvisi.fbf667d5.svg";